import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'languages';

const LanguagesGenerator = createRestAPIModelGenerator(TYPE);
export default LanguagesGenerator.createValueListModel();
